import { TextField as MuiTextField } from '@mui/material'
import type { FieldMeta } from '@crm/shared'

interface LongTextFieldProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  hideLabel?: boolean
}

export function LongTextField({ field, value, mode, onChange, error, disabled, hideLabel }: LongTextFieldProps) {
  if (mode === 'view') {
    const text = value != null ? String(value) : ''
    if (!text) return <span />
    if (text.length <= 200) return <span style={{ whiteSpace: 'pre-wrap' }}>{text}</span>
    return <span style={{ whiteSpace: 'pre-wrap' }}>{text.slice(0, 200)}...</span>
  }

  return (
    <MuiTextField
      label={hideLabel ? undefined : field.label}
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      error={!!error}
      helperText={error}
      disabled={disabled}
      required={!!field.is_required}
      size="small"
      fullWidth
      multiline
      minRows={3}
      maxRows={8}
      slotProps={{ htmlInput: { maxLength: 5000 } }}
    />
  )
}
